import React, { useState } from "react";
import Modal from "react-modal";
import "../css/PassengerInformation.css";
import { useQueryClient } from "@tanstack/react-query";
import DocumentViewer from "../../../components/elements/DocumentViewer";
import useLandingAuthApi from "../../../services/api/useLandingAuthApi";
import { calculateAge } from "../../../utils/Utils";


const PassengerInformation = ({ passengers }) => {
  const queryClient = useQueryClient();
  const { getDocument } = useLandingAuthApi();
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewDocument = async (passengerId) => {
    setIsModalOpen(true);

    try {
      const response = await queryClient.fetchQuery({
        queryKey: ["document", passengerId],
        queryFn: () => getDocument(passengerId),
      });

      const documentUrl = response?.documentUrl;
      const documentName = response?.documentName;

      if (documentUrl && documentName) {
        setSelectedDocument({ documentUrl, documentName });
      } else {
        setIsModalOpen(false);
      }
    } catch (error) {
      setIsModalOpen(false);
    }
  };

  
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedDocument(null);
  };
  return (
    <div className="passenger-info-container">
      <p>Passenger Information ({passengers?.length})</p>
      <div className="passenger-info-container-box">
        <ul>
          {passengers.map((passenger, index) => (
            <li key={index} className="passenger-item">
              <div className="passenger-details">
                <span className="passenger-number">{index + 1}</span>
                <span className="passenger-name">{passenger?.fullName}</span>
              </div>
              <div className="passenger-info-right">
                {passenger?.documentName && (
                  <div className="passenger-view-document" data-testid="view-document-link">
                    <a
                      href="#"
                      className="view-document"
                      onClick={(e) => {
                        e.preventDefault();
                        handleViewDocument(passenger?.id);
                      }}
                    >
                      View Document
                    </a>
                  </div>
                )}
                <div className="passenger-age-gender">
                  Age {calculateAge(passenger.dateOfBirth)}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        overlayClassName="passenger-modal-overlay"
        className="passenger-modal-content"
      >
        {selectedDocument ? (
          <DocumentViewer
            documentUrl={selectedDocument.documentUrl}
            documentName={selectedDocument.documentName}
            onClose={closeModal}
          />
        ) : (
          <div className="document-viewer document-viewer-modal">
            <div className="document-viewer-modal-body document-viewer-loading-container">
              <div className="document-viewer-loading">Loading...</div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default PassengerInformation;
